import { ProductAttributes } from "../../hooks/useStandardProducts";

type ScalarArray = Array<string | number | boolean | undefined>;

export const ATTRIBUTES = {
  COVER_TYPE: "coverType",
  COVER_FINISH: "coverFinish",
  TEXT_STOCK: "textStock",
  DIMENSIONS: "dimensions",
  ORIENTATION: "orientation",
  BIND_TYPE: "bindType",
} as const;

export function isSoftcover(attributes: ProductAttributes) {
  const softcoverTypes: ScalarArray = ["SCIW"];
  return softcoverTypes.indexOf(attributes[ATTRIBUTES.COVER_TYPE]) >= 0;
}

export function isHardcover(attributes: ProductAttributes) {
  const hardcoverTypes: ScalarArray = ["HCIW"];
  return hardcoverTypes.indexOf(attributes[ATTRIBUTES.COVER_TYPE]) >= 0;
}
